<div class="pb-2 main-process-container">
    <!-- Data table component -->
 <div class="d-flex justify-content-between align-items-center process-execution">
  <h5>Process Execution Status</h5>
    <button class="close-button" (click)="onClose()">&#x2715;</button>
 </div>
  <app-gis-data-table
    [data]="processList"
    [columns]="displayColumns"
    [getStatusClass]="getStatusClass"
    [buttons]="buttonConfig"
  >
  </app-gis-data-table>

</div>
<ngx-loading [show]="isLoading" [config]="{backdropBackgroundColour: 'rgba(255,255,255,0.3)'}"></ngx-loading>